import { createContext } from 'react';
import utils from 'utils';

type WorkflowPopupNotificationContextProps = {
  setField: (fieldId: string) => void;
  startCountdown: () => void;
};

export default createContext<Partial<WorkflowPopupNotificationContextProps>>({
  setField: utils.noop,
  startCountdown: utils.noop,
});
